module.exports = __webpack_public_path__ + "static/media/circle.aa128254.svg";